module.exports = __webpack_public_path__ + "b2b3dd6031104649985f8394f2eed22a.pdf";